export const BOARD = 'board';
export const CLEANUP = 'cleanup';
export const INDEX = 'index';